<!-- 工频电场 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">{{tableData[0]&&tableData[0].desc}}</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="hz" label="频率（f，MHz）">
      </el-table-column>
      <el-table-column align="center" prop="electricIntensity" label="电场强度（kV／m）">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.getTableData()
    },
    methods:{
      async getTableData(){
        let res = await this.$axios.get(this.$serviceAPI.findPowerFrequencyElectric)
        this.tableData = res.data.data
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/powerFrequencyElectric.vue